<script setup>
import { reactiveOmit } from '@vueuse/core';
import { StepperTitle, useForwardProps } from 'reka-ui';
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <StepperTitle
    v-bind="forwarded"
    :class="cn('text-md font-semibold', props.class)"
  >
    <slot />
  </StepperTitle>
</template>
